<script lang="ts">
  import Upload from '../icons/Upload.svelte';

  let {
    onFileSelect,
    uploading = false,
    disabled = false
  }: {
    onFileSelect: (files: FileList) => void;
    uploading?: boolean;
    disabled?: boolean;
  } = $props();

  function handleFileChange(event: Event): void {
    const files = (event.target as HTMLInputElement).files;
    if (files && files.length > 0) {
      onFileSelect(files);
      // Reset the input
      (event.target as HTMLInputElement).value = '';
    }
  }
</script>

<label for="file-input" class="upload-dropzone" class:disabled={disabled}>
  <Upload size={32} class="upload-icon" />
  <div class="upload-text">
    {#if uploading}
      <p class="uploading-text">Processing files...</p>
    {:else if disabled}
      <p class="main-text">Select bank and person first</p>
      <p class="hint-text">Choose where to save the CSV files</p>
    {:else}
      <p class="main-text">Click to upload CSV files</p>
      <p class="hint-text">Supports multiple files from Chase, Capital One, Amex, etc.</p>
    {/if}
  </div>
  <input
    id="file-input"
    type="file"
    accept=".csv"
    multiple
    onchange={handleFileChange}
    disabled={uploading || disabled}
  />
</label>

<style lang="scss">
  .upload-dropzone {
    display: flex;
    align-items: center;
    gap: var(--spacing-lg);
    padding: var(--spacing-xl);
    background: var(--color-background);
    border: 2px dashed var(--color-border);
    border-radius: var(--radius-lg);
    cursor: pointer;
    transition: all var(--transition-fast);

    &:hover:not(.disabled) {
      background: var(--color-background-secondary);
      border-color: var(--color-primary);

      :global(.upload-icon) {
        color: var(--color-primary);
        transform: translateY(-2px);
      }
    }

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    input[type="file"] {
      display: none;
    }
  }

  :global(.upload-icon) {
    color: var(--color-text-tertiary);
    transition: all var(--transition-fast);
  }

  .upload-text {
    flex: 1;

    .main-text {
      font-size: var(--font-size-base);
      font-weight: var(--font-weight-medium);
      color: var(--color-text-primary);
      margin: 0;
    }

    .uploading-text {
      font-size: var(--font-size-base);
      font-weight: var(--font-weight-medium);
      color: var(--color-primary);
      margin: 0;
    }

    .hint-text {
      font-size: var(--font-size-sm);
      color: var(--color-text-tertiary);
      margin: var(--spacing-xs) 0 0 0;
    }
  }

  @media (max-width: 640px) {
    .upload-dropzone {
      flex-direction: column;
      text-align: center;
      gap: var(--spacing-md);
    }
  }
</style>
